import PropTypes from 'prop-types';
import { ToastNotification } from 'ypf-pas-general-ui-components/dist';
import { useCallback, useState, createContext } from 'react';

const ToastContext = createContext();

export default ToastContext;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const setNewToast = useCallback(
    (toast) => {
      setToasts(() => [toast]);
    },
    [setToasts]
  );

  const closeToast = () => {
    setToasts((tst) => tst.slice(1), 3000);
  };

  return (
    <ToastContext.Provider
      value={{
        setNewToast,
        closeToast
      }}
    >
      {children}
      {toasts?.map((toast, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <ToastNotification
          // eslint-disable-next-line react/no-array-index-key
          key={`${index}-toast.mensaje`}
          options={toast?.options ? toast.options : null}
          toast={toast}
        />
      ))}
    </ToastContext.Provider>
  );
}

ToastProvider.propTypes = {
  children: PropTypes.node.isRequired
};
